export default __webpack_public_path__ + "static/media/analytics.008e6a49.svg";